export default __webpack_public_path__ + "b6251d1fcfa2ed3120015691f2b10cb7.png";